<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M140.001-260.001v-45.384H355v45.384H140.001Zm0-197.307v-45.384h447.306v45.384H140.001Zm0-197.307v-45.384h679.998v45.384H140.001Z"/></svg>
</template>
